module.exports = __webpack_public_path__ + "img/icon_import.091ade3f.svg";